import React from 'react'
import { Box, Checkbox, Stack, Typography } from '@mui/material'
import type { OrgMemberRow } from 'pure-js/types/OrganizationMembership'

import { getOrgMemberLabel } from './leaderScopeHelpers'
import {
  leaderScopeBodyTextSx,
  leaderScopeCaptionSx,
  leaderScopeCheckboxSx,
  leaderScopePersonRowSx
} from './leaderScopeStyles'

export type LeaderScopePersonRowProps = {
  member: OrgMemberRow
  isSelected: boolean
  onToggle: (userId: string) => void
}

/** One participant of the tick list: the whole row toggles them, the name first and the email beneath. */
export const LeaderScopePersonRow: React.FC<LeaderScopePersonRowProps> = ({ member, isSelected, onToggle }) => (
  <Stack
    direction="row"
    spacing={1}
    alignItems="center"
    sx={leaderScopePersonRowSx}
    onClick={() => onToggle(member.userId)}
  >
    <Checkbox
      checked={isSelected}
      inputProps={{ 'aria-label': getOrgMemberLabel(member) }}
      sx={leaderScopeCheckboxSx}
    />

    <Box sx={{ minWidth: 0 }}>
      <Typography sx={leaderScopeBodyTextSx}>{member.displayName || '—'}</Typography>
      <Typography sx={{ ...leaderScopeCaptionSx, wordBreak: 'break-all' }}>{member.email || ''}</Typography>
    </Box>
  </Stack>
)
